import PreAuthorizationRequest from './PreAuthorizationRequest';

export default PreAuthorizationRequest;